import React, {Component} from 'react'
import Select from 'react-select'
import 'react-select/dist/react-select.css'
import LaddaButton, {SLIDE_UP} from '../LaddaButton'

class AddGym extends Component {
  constructor(props) {
    super(props)
    this.state = {
      publicListing: 1,
    }
    this.handleCreateClick = this.handleCreateClick.bind(this)
    this.handleNameChange = this.handleNameChange.bind(this)
  }

  handleCreateClick(e) {
    e.preventDefault()
    if (!this.state.gymName) {
      this.setState({
        errors: ['Please add a gym name'],
      })
      return
    }
    this.setState({
      loading: true,
    })

    // TODO: Add proper random key for gyms
    window.firebaseDb
      .collection('gyms')
      .doc(this.state.gymName.toLowerCase())
      .set({
        walls: {},
        name: this.state.gymName,
      })
      .then(() => {
        this.setState({
          loading: false,
        })
        this.props.cancel()
      })
  }

  handleNameChange(e) {
    this.setState({
      gymName: e.target.value,
      errors: undefined,
    })
  }
  handlePrivacyChange = selectedOption => {
    this.setState({
      publicListing: selectedOption.value,
    })
  }
  render() {
    return (
      <form style={{width: '100%'}}>
        <h1>Add a new gym</h1>
        <div className="form-group">
          <label>Gym Name:</label>
          <div className="input-wrapper">
            <input placeholder="..." onChange={this.handleNameChange}></input>
          </div>
        </div>
        <div className="form-group">
          <Select
            className="form-select"
            value={this.state.publicListing}
            onChange={this.handlePrivacyChange}
            clearable={false}
            placeholder="Select grade"
            options={[
              {value: 0, label: 'Keep Gym Private'},
              {value: 1, label: 'List Gym Publicly'},
            ]}
            searchable={false}
            autosize={false}
            disabled={false}
          />
        </div>
        {this.state.errors && (
          <div className="form-group form-errors">
            {this.state.errors.map((e, index) => {
              return <div key={index}>{e}</div>
            })}
          </div>
        )}
        <LaddaButton
          loading={this.state.loading}
          onClick={this.handleCreateClick}
          data-color="mint"
          data-style={SLIDE_UP}
          data-spinner-color="#ddd"
          className={'half-width'}>
          Create
        </LaddaButton>
        <LaddaButton
          onClick={this.props.cancel}
          data-color="#eee"
          data-style={SLIDE_UP}
          data-spinner-color="#ddd"
          className={'half-width'}>
          Cancel
        </LaddaButton>
      </form>
    )
  }
}

export default AddGym



// WEBPACK FOOTER //
// ./src/components/gyms/AddGym.jsx